"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidebarLibraryFolders = exports.BASE_CLASS_NAME = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var mobx_1 = require("mobx");
var SavedBlockFilterViewStore_1 = require("SavedBlock/SavedBlockFilterViewStore");
var Images_1 = require("../Images");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var BlockLibraryTab_1 = require("../Blocks/BlockLibraryTab");
var ImageFolders_1 = require("../Images/ImageFolders/ImageFolders");
var react_transition_group_1 = require("react-transition-group");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var BlockFolders_1 = require("../Blocks/BlockFolders");
var DashboardTypes_1 = require("@CommonFrontendBackend/Dashboard/DashboardTypes");
var ContentSidebarLibraryViewStore_1 = require("../Library/ContentSidebarLibraryViewStore");
exports.BASE_CLASS_NAME = "content-sidebar";
var FOLDER_ITEM_CLASS_NAME = "".concat(exports.BASE_CLASS_NAME, "__folder-item");
var SidebarLibrary = (function (_super) {
    __extends(SidebarLibrary, _super);
    function SidebarLibrary(props) {
        var _this = _super.call(this, props) || this;
        _this.onContentSidebarCloseDisposer = null;
        _this.listenToClickForHidingFoldersDisposer = null;
        _this.renderBlockLibraryTab = function () {
            return (react_1.default.createElement(BlockLibraryTab_1.BlockLibraryTab, { savedBlockViewStore: _this.props.savedBlockViewStore, useHistoryDataStore: _this.props.useHistoryDataStore, contentSidebarViewStore: _this.props.contentSidebarViewStore, contentSidebarLibraryViewStore: _this.props.contentSidebarLibraryViewStore, dragStore: _this.props.dragStore, dropzonesStore: _this.props.dropzonesStore, savedBlockOpener: _this.props.savedBlockOpener, userIsAdmin: _this.props.userIsAdmin, savedBlocksFolderViewStore: _this.props.savedBlocksFolderViewStore, telemetry: _this.props.telemetry, accountId: _this.props.accountId, canEditQuoteV1: _this.props.canEditQuoteV1, thumbnailBaseUrl: _this.props.thumbnailBaseUrl, usingFeature: _this.props.usingFeature }));
        };
        _this.renderImageLibraryTab = function () {
            return (react_1.default.createElement(Images_1.ImageLibraryTab, { dragStore: _this.props.dragStore, imageServices: _this.props.imageServices, disableImgix: _this.props.disableImgix, clickToAddStore: _this.props.clickToAddStore, uploadStore: _this.props.uploadStore, sidebarImageViewStore: _this.props.sidebarImageViewStore, imageLibraryDataStore: _this.props.imageLibraryDataStore, contentSidebarViewStore: _this.props.contentSidebarViewStore, contentSidebarLibraryViewStore: _this.props.contentSidebarLibraryViewStore, dropLocationStore: _this.props.dropLocationStore, duplicateUploadNotifier: _this.props.duplicateUploadNotifier, fileInputRef: _this.props.fileInputRef, onUpload: _this.props.onUpload, handleOpenImageLibrary: _this.props.handleOpenImageLibrary }));
        };
        _this.getTabPanelInnerFromKey = function (key) {
            switch (key) {
                case ContentSidebarLibraryViewStore_1.ContentSidebarTab.Blocks:
                    return _this.renderBlockLibraryTab();
                case ContentSidebarLibraryViewStore_1.ContentSidebarTab.Image:
                    return _this.renderImageLibraryTab();
                default:
                    throw new Error("Tab has no corresponding panel: ".concat(key));
            }
        };
        _this.handleTabChange = function (index) {
            var tab = ContentSidebarLibraryViewStore_1.CONTENT_SIDEBAR_TABS[index].key;
            _this.props.contentSidebarLibraryViewStore.setCurrentTab(tab);
            _this.props.telemetry.trackOnly("Sidebar Tab Selected", {
                sidebar_tab_type: (0, ContentSidebarLibraryViewStore_1.contentSidebarTabToSidebarTabTypeTelem)(tab),
            }, { blockIntercom: true });
        };
        _this.savedBlockFilterViewStore = new SavedBlockFilterViewStore_1.SavedBlockFilterViewStore(_this.props.savedBlockViewStore);
        _this.onClickOutside = new utils_1.OnClickOutside([".content-sidebar"], _this.props.contentSidebarLibraryViewStore.hideFolders);
        return _this;
    }
    SidebarLibrary.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, Promise, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.props.savedBlockViewStore.bind();
                        this.onContentSidebarCloseDisposer = (0, mobx_1.autorun)(function () {
                            if (!_this.props.contentSidebarLibraryViewStore.isTabCurrentlyOpen(ContentSidebarLibraryViewStore_1.ContentSidebarTab.Blocks)) {
                                _this.props.savedBlockViewStore.resetPagination();
                            }
                        });
                        this.listenToClickForHidingFoldersDisposer = (0, mobx_1.autorun)(function () {
                            if (_this.props.contentSidebarLibraryViewStore.isShowingFolders) {
                                _this.onClickOutside.startListening();
                            }
                            else {
                                _this.onClickOutside.stopListening();
                            }
                        });
                        return [4, this.props.savedBlockViewStore.filterSavedBlocksByFolderId(DashboardTypes_1.SavedBlockCollection.All)];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    SidebarLibrary.prototype.componentWillUnmount = function () {
        this.props.savedBlockViewStore.unbind();
        this.onContentSidebarCloseDisposer && this.onContentSidebarCloseDisposer();
        this.listenToClickForHidingFoldersDisposer && this.listenToClickForHidingFoldersDisposer();
        this.onClickOutside.stopListening();
    };
    SidebarLibrary.prototype.render = function () {
        var _this = this;
        var headerComponent = this.props.headerComponent;
        return this.hasTabs ? (react_1.default.createElement(kaleidoscope_1.Tabs, { selectedIndex: this.selectedTabIndex, onChange: this.handleTabChange, className: "".concat(exports.BASE_CLASS_NAME, "__tab-container") },
            react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME, "__header") },
                !!headerComponent && headerComponent,
                react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME, "__header-bottom") },
                    react_1.default.createElement(kaleidoscope_1.TabList, { "aria-label": "Library tabs" }, ContentSidebarLibraryViewStore_1.CONTENT_SIDEBAR_TABS.map(function (tab) { return (react_1.default.createElement(kaleidoscope_1.Tab, { key: tab.key }, tab.displayName)); }))),
                this.renderPrompt),
            react_1.default.createElement(kaleidoscope_1.TabPanels, { className: "content-sidebar__tab-panels" }, ContentSidebarLibraryViewStore_1.CONTENT_SIDEBAR_TABS.map(function (tab) { return (react_1.default.createElement(kaleidoscope_1.TabPanel, { className: "content-sidebar__tab-panel", key: tab.key }, _this.getTabPanelInnerFromKey(tab.key))); })))) : (react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME, "__content-wrapper") },
            !!headerComponent && react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME, "__header") }, headerComponent),
            this.renderBlockLibraryTab()));
    };
    Object.defineProperty(SidebarLibrary.prototype, "renderPrompt", {
        get: function () {
            var _a = this.props.contentSidebarLibraryViewStore, currentPrompt = _a.currentPrompt, isShowingPrompt = _a.isShowingPrompt;
            return (react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME, "__prompt") },
                react_1.default.createElement(react_transition_group_1.CSSTransition, { mountOnEnter: true, unmountOnExit: true, in: isShowingPrompt, timeout: 400, classNames: "".concat(currentPrompt.class, "-") },
                    react_1.default.createElement("div", { className: currentPrompt.class },
                        react_1.default.createElement("div", { "aria-live": "polite", className: "".concat(currentPrompt.class, "__text") }, currentPrompt.text)))));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SidebarLibrary.prototype, "hasTabs", {
        get: function () {
            return this.props.sidebarImagesEnabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SidebarLibrary.prototype, "selectedTabIndex", {
        get: function () {
            var currentTab = this.props.contentSidebarLibraryViewStore.currentTab;
            return ContentSidebarLibraryViewStore_1.CONTENT_SIDEBAR_TABS.findIndex(function (t) { return t.key === currentTab; });
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], SidebarLibrary.prototype, "renderPrompt", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], SidebarLibrary.prototype, "selectedTabIndex", null);
    SidebarLibrary = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], SidebarLibrary);
    return SidebarLibrary;
}(react_1.default.Component));
exports.default = SidebarLibrary;
exports.SidebarLibraryFolders = (0, mobx_react_1.observer)(function (_a) {
    var contentSidebarLibraryViewStore = _a.contentSidebarLibraryViewStore, savedBlocksFolderViewStore = _a.savedBlocksFolderViewStore, imageFolderViewStore = _a.imageFolderViewStore, savedBlockViewStore = _a.savedBlockViewStore, sidebarImageViewStore = _a.sidebarImageViewStore;
    var closeFolders = (react_1.default.createElement(kaleidoscope_1.IconButton, { tooltip: {
            content: "Hide folders",
            position: kaleidoscope_1.TooltipPosition.Top,
        }, type: kaleidoscope_1.ButtonType.Tertiary, icon: react_1.default.createElement(icons_1.ChevronLeft, null), width: "normal", size: kaleidoscope_1.ButtonSize.Small, onClick: contentSidebarLibraryViewStore.hideFolders }));
    var foldersContents = contentSidebarLibraryViewStore.currentTab === ContentSidebarLibraryViewStore_1.ContentSidebarTab.Blocks ? (react_1.default.createElement(react_transition_group_1.CSSTransition, { key: "blocks", classNames: FOLDER_ITEM_CLASS_NAME, timeout: kaleidoscope_2.AnimationDuration.Short },
        react_1.default.createElement("div", { className: FOLDER_ITEM_CLASS_NAME },
            react_1.default.createElement(BlockFolders_1.BlockFolders, { savedBlocksFolderViewStore: savedBlocksFolderViewStore, closeFoldersSlot: closeFolders, savedBlockViewStore: savedBlockViewStore })))) : (react_1.default.createElement(react_transition_group_1.CSSTransition, { key: "images", classNames: FOLDER_ITEM_CLASS_NAME, timeout: kaleidoscope_2.AnimationDuration.Short },
        react_1.default.createElement("div", { className: FOLDER_ITEM_CLASS_NAME },
            react_1.default.createElement(ImageFolders_1.ImageFolders, { folderViewStore: imageFolderViewStore, onSelectFolder: sidebarImageViewStore.selectFolder, closeFoldersSlot: closeFolders, selectedFolder: sidebarImageViewStore.currentFolder }))));
    return (react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME, "__folder-container") },
        react_1.default.createElement(react_transition_group_1.TransitionGroup, { component: null }, foldersContents)));
});
